import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { shadowLight } from '../../app/colors';
import { gray, red } from '@kizen/kds/Colors';

// TODO The original color for this was dark red when developed for inline editing.
// Over time the designs have displayed it lighter, so we support this variant.
// Hopefully we can standardize the color at some point. It may also be intentional
// depending on the context of the error, currently unsure.

export default styled.div`
  border: 1px solid ${red['red-700']};
  ${({ light }) =>
    light &&
    css`
      border-color: ${red['red-500']};
    `}
  border-radius: 4px;
  background: ${gray['gray-50']};
  ${shadowLight}
  padding: 10px;
  max-width: 90%;

  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity ${({ duration = '0.5s' }) => duration} ease-in-out;
`;
